import { useMutation } from '@tanstack/react-query'
import { api } from '@api'

interface GenerateScheduledMessageData {
  recipientAccountId?: string
  groupId?: string
  language?: string
  reason: string
  additionalDetails?: string
  scheduledDate?: string
}

interface GenerateScheduledMessageResponse {
  message: string
}

const generateScheduledMessage = async (data: GenerateScheduledMessageData): Promise<GenerateScheduledMessageResponse> => {
  const { data: responseData } = await api.post<GenerateScheduledMessageResponse>('/scheduled-message/generate', data)
  return responseData
}

export const useGenerateScheduledMessage = () => {
  return useMutation<GenerateScheduledMessageResponse, Error, GenerateScheduledMessageData>({
    mutationFn: generateScheduledMessage,
  })
}
